module.exports = __webpack_public_path__ + "img/amathus.f4cdc13d.png";